import React from 'react'
import { Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import store from 'store'
import { includes } from 'lodash-es'
import { parse } from 'query-string'
import { replace } from 'connected-react-router'
import { matchPath } from 'react-router'
import { Helmet } from 'components/UI'
import { clearAuthTokens, isTokenExist, setToken } from 'utils/cookies'
import { setSelectedEndpoint } from 'app-redux/companies/actions'
import { resetInits } from 'app-redux/inits/actions'
import { inits } from 'app-redux/actions'
import { hideAccountTransactionReport } from 'app-redux/finance/actions'
import { setErrorLoginForm } from 'app-redux/loginSlice'
import { resetUser } from 'app-redux/initSlice'
import { decodeUriWithAtob } from 'utils/helper'
import PublicLayout from './Public'
import LoginLayout from './Login'
import MainLayout from './Main'
import SelectCompanyLayout from './SelectCompany'
import NoCompanyLayout from './Main/NoCompany'
import InfoLayout from './Info'
import CashierLayout from './Cashier'
import CustomerDisplayLayout from './CustomerDisplay'
import PublicShopifyLayout from './PublicShopify'
import PushNotificationSync from './PushNotificationSync'

const Layouts = {
  public: PublicLayout,
  login: LoginLayout,
  main: MainLayout,
  selectCompany: SelectCompanyLayout,
  noCompanyLayout: NoCompanyLayout,
  info: InfoLayout,
  cashier: CashierLayout,
  customerDisplay: CustomerDisplayLayout,
  publicShopify: PublicShopifyLayout,
}

const avoidRouteWhenAuthorized = [
  '/user/select-company',
  '/user/billing/success',
  '/user/billing/failed',
  '/companies/add',
]
const infoPages = ['/maintenance']
const execludePreviousPages = ['/', '/user/select-company']
const shopifyPublicPages = ['/shopify-claim']
const publicPages = ['/user/request-delete-account', '/user/invite']

class IndexLayout extends React.PureComponent {
  // eslint-disable-next-line react/state-in-constructor

  constructor(props) {
    super(props)
    this.state = {
      containerKey: 0,
    }
  }

  componentDidMount() {
    // eslint-disable-next-line no-restricted-globals
    const searchs = parse(location.search)

    // if there is error params, show error
    if (searchs.error) {
      this.props.setErrorLoginForm(searchs.error)
      // eslint-disable-next-line no-restricted-globals
      history.replaceState(null, null, `${location.pathname}${location.hash}`)
    }
    this.loginFromOtherApp()
  }

  componentDidUpdate(prevProps) {
    const { location, user } = this.props
    const { location: prevLocation } = prevProps

    if (location.pathname !== prevLocation.pathname && location.pathname !== '/user/login') {
      if (location.state) {
        if (location.state.resetscroll) {
          window.scrollTo(0, 0)
        }
      }
      // Untuk hide modal report accountTransaction
      if (this.props.accountTransactionReport.show) {
        this.props.hideAccountTransactionReport()
      }
    }

    if (prevProps.user.email !== user.email) {
      // set inspectlet identity
      if (window.__insp) {
        window.__insp.push(['identify', user.email])
      }
    }
  }

  getSnapshotBeforeUpdate(prevProps) {
    if (
      prevProps.companies.selectedEndpoint !== this.props.companies.selectedEndpoint &&
      prevProps.companies.selectedEndpoint &&
      this.props.companies.selectedEndpoint
    ) {
      this.props.inits().then(() => {
        this.setState({ containerKey: this.props.companies.selectedEndpoint })
      })
    }
    return null
  }

  getLayout = () => {
    const {
      location: { pathname, search },
    } = this.props
    const searchs = parse(search)

    if (shopifyPublicPages.some((path) => pathname.startsWith(path))) {
      return 'publicShopify'
    }

    if (publicPages.some((path) => pathname.startsWith(path))) {
      return 'public'
    }

    if (infoPages.some((path) => pathname.startsWith(path))) {
      return 'info'
    }

    if (pathname.startsWith('/cashier/display')) {
      return 'customerDisplay'
    }
    if (pathname.startsWith('/cashier')) {
      return 'cashier'
    }

    if (pathname === '/user/select-company') {
      return 'selectCompany'
    }
    if (/^\/user(?=\/|$)/i.test(pathname)) {
      return 'login'
    }

    if (pathname === '/companies/add' && !!searchs.from_login) {
      return 'noCompanyLayout'
    }
    return 'main'
  }

  loginFromOtherApp = () => {
    // eslint-disable-next-line no-restricted-globals
    const { search } = location
    const searchs = parse(search)

    // if there is token params, set token
    if (searchs.token) {
      store.remove('app.previousPathname')
      store.remove('app.endpoint')
      clearAuthTokens()
      this.props.setSelectedEndpoint(null)
      this.props.resetUser({ logout: true })
      this.props.resetInits()
      setToken(searchs.token)
      // if there is endpoint params, set endpoint
      if (searchs.endpoint) {
        store.set('app.endpoint', searchs.endpoint)
        this.props.setSelectedEndpoint(searchs.endpoint)
      }
      // Hilangkan search params token
      // eslint-disable-next-line no-restricted-globals
      history.replaceState(null, null, `${location.pathname}${location.hash}`)
    }
  }

  bootstrappedLayout = () => {
    const {
      children,
      location: { pathname, search },
      user,
      companies,
      isExpired,
    } = this.props
    const searchs = parse(search)
    const storeEndpoint = store.get('app.endpoint')
    // Layout Rendering
    const layout = this.getLayout()
    const Container = Layouts[layout]
    const currentLayout = (
      <Container key={this.state.containerKey} companies={companies}>
        {children}
      </Container>
    )

    const isUserAuthorized = isTokenExist()
    const isLoginLayout = layout === 'login'
    const isPublicLayout = layout === 'public'

    // Shopify claim pages are guest-only.
    if (pathname === '/shopify-claim') {
      if (isUserAuthorized) {
        return <Redirect to={`/shopify-claim/companies${search || ''}`} />
      }
      return currentLayout
    }

    // Shopify claim companies page requires authentication.
    if (pathname === '/shopify-claim/companies') {
      if (!isUserAuthorized) {
        return <Redirect to="/shopify-claim" />
      }
      return currentLayout
    }

    if (isPublicLayout) {
      return currentLayout
    }

    // redirect to login page if current is not login page and user not authorized
    if ((!isLoginLayout || pathname === '/user/select-company') && !isUserAuthorized) {
      // Jika tidak ada token dan tidak melakukan logout, hapus localstorage endpoint
      if (!user.logout) {
        store.remove('app.endpoint')
      }
      if (!includes(execludePreviousPages, pathname)) {
        store.set('app.previousPathname', pathname)
      } else {
        return <Redirect to="/user/login" />
      }
      return currentLayout
    }

    // Jika sudah login dan belum memilih perushaan (kalau perusahaan lebih dari satu) dan posisinya tidak di billing dan select company
    if (
      isUserAuthorized &&
      !companies.selectedEndpoint &&
      !storeEndpoint &&
      !includes(avoidRouteWhenAuthorized, pathname) &&
      !pathname.startsWith('/shopify-claim')
    ) {
      if (!isLoginLayout && !includes(execludePreviousPages, pathname)) {
        store.set('app.previousPathname', pathname)
      }

      return <Redirect to="/user/select-company" />
    }

    if (!companies.selectedEndpoint && storeEndpoint) {
      this.props.setSelectedEndpoint(storeEndpoint)
    }

    // const isExpired = expiryDate ? dayjs(expiryDate).isBefore(dayjs()) : false
    // dayjs().subtract(1, 'days').isAfter(expiryDate)
    // Jika sudah login dan expired serta sudah ada endpoint
    if (isUserAuthorized && !isLoginLayout && (companies.selectedEndpoint || storeEndpoint)) {
      if (isExpired && !pathname.includes('/billing')) {
        return <Redirect to="/settings/billing" />
      }
    }

    // redirect to main dashboard when user on login page or select company page and authorized
    if (
      (isLoginLayout || pathname === '/user/select-company') &&
      !/^\/user\/invite(?=\/|$)/i.test(pathname) &&
      pathname !== '/user/billing/success' &&
      pathname !== '/user/billing/failed' &&
      isUserAuthorized &&
      (companies.selectedEndpoint || store.get('app.endpoint'))
    ) {
      if (store.get('app.previousPathname')) {
        return <Redirect to={store.get('app.previousPathname')} />
      }

      const isTwoFactorRequired = pathname.includes('/user/login/two-factor-required')
      const isOtpLogin = pathname === '/user/login/otp'

      const decodeParams = decodeUriWithAtob(
        isTwoFactorRequired
          ? matchPath(pathname, { path: '/user/login/two-factor-required/:data', exact: true })
              .params.data
          : isOtpLogin
            ? searchs?.data
            : '',
        false,
      )

      if (isOtpLogin && decodeParams?.source?.startsWith('/shopify-claim')) {
        const source = decodeParams.source || ''
        const sourceSearch = source.includes('?') ? source.slice(source.indexOf('?')) : ''
        const sourceParams = parse(sourceSearch)
        const shopQuery = sourceParams?.shop ? `?shop=${encodeURIComponent(sourceParams.shop)}` : ''

        return <Redirect to={`/shopify-claim/companies${shopQuery}`} />
      }

      // Source digunakan di shopify claim untuk redirect ke halaman yang sama
      return <Redirect to={decodeParams?.source || '/dashboard'} />
    }

    // in other case render previously set layout
    return currentLayout
  }

  render() {
    return (
      <>
        <Helmet titleTemplate="Kledo | %s" title="Kledo Software" />
        <PushNotificationSync />
        {this.bootstrappedLayout()}
      </>
    )
  }
}

const mapStateToProps = ({
  _inits: { user },
  companies,
  billing,
  finance: { accountTransactionReport },
  router: { location, match },
}) => ({
  user,
  companies,
  isExpired: billing.is_expired,
  accountTransactionReport,
  location,
  match,
})

const mapDispatchToProps = {
  setSelectedEndpoint,
  inits,
  hideAccountTransactionReport,
  setErrorLoginForm,
  resetInits,
  replacePath: replace,
  resetUser,
}

export default connect(mapStateToProps, mapDispatchToProps)(IndexLayout)
